import e from "react";
import { Flex as r } from "../Flex/Flex.js";
import { Text as t } from "../Text/Text.js";
import { VisuallyHidden as i } from "../VisuallyHidden/VisuallyHidden.js";
const l = _ref => {
  let {
    price: o,
    caption: n
  } = _ref;
  return e.createElement(r, {
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "column"
  }, e.createElement(t.BodyMedium, {
    marginBottom: "--spacing-0-5",
    weight: "bold"
  }, e.createElement(i, null, "Pre\xE7o: "), o), e.createElement(t.Caption, null, n));
};
export { l as PriceLabel };